query CurrentMember($companyId: ID!) {
  currentMember(companyId: $companyId) {
    id
    role
  }
}